module.exports = __webpack_public_path__ + "static/home1-sidebar-banner2-adf4be9b710c79f2ec30683fedc0d809.jpg";